<template>
  <div class="home">
    <!-- <readWord class="readWord" :msg="[arrWord]" /> -->
    <div class="todayWord" @click="tabRead">
      <div v-if="!isRead">
        今日在背
        <div>单词数:{{arrWord.length}}</div>
      </div>
      <div v-if="isRead">
        点击返回
        <div>总数:{{arrWord.length}}</div>
        <div>已背:{{arrRecite.length}}</div>
        <div>还差:{{arrWord.length - arrRecite.length}}</div>
      </div>
    </div>
    <!-- nav开启与否 -->
    <button class="navBtn" v-show="!nav" @click="closeNav">导航</button>
    <!-- 单词详情 -->
    <div class="ts" v-if="ts.length != 0">
      <div class="close" @click="close">
        <div class="close1"></div>
        <div class="close2"></div>
      </div>
      <div class="tranBox flexCll">
        <template v-if="ts.basic">
          <audio :src="ts.basic['uk-speech']" controls="controls" autoplay></audio>
          <div class="flex font18">{{ ts.query }}[{{ ts.basic["uk-phonetic"] }}]</div>
        </template>
        <div
          class="inlineBlock"
          v-for="tran in ts.translation"
          v-bind:key="tran.index"
        >翻译：{{ tran }}</div>
        <template v-if="ts.basic">
          <div v-for="all in ts.basic.explains" v-bind:key="all.index">
            <div>{{ all }}</div>
          </div>
        </template>
        <div v-if="ts.web">
          网络翻译：
          <div v-for="web in ts.web" v-bind:key="web.index">
            {{ web.key }}:
            <span v-for="value in web.value" v-bind:key="value.index">{{ value }};</span>
          </div>
        </div>
      </div>
    </div>
    <div class="wordBox pd20">
      <!-- 导航头 -->
      <div class="nav" v-show="nav" @click="closeNav">
        <template v-for="size in abcz">
          <a :href="`#` + size" :key="size.index">{{ size }}</a>
        </template>
      </div>
      <!-- 单词列表 此为在背单词-->
      <template v-if="isRead">
        <div class="topNote">
          <button @click="clearNote">点我清空单词本</button>
          左滑:已背 右滑:未背 上划:删除
        </div>
        <div class="listBox">
          <template v-for="(item,index) in list">
            <v-touch
              v-on:swipeleft="swiperleft(item)"
              v-on:swiperight="swiperright(item)"
              v-on:swipeup="swiperup(index)"
              class="wrapper"
              :key="item.index"
            >
              <div
                class="item"
                :class="[item==classActive ? 'classActive' : '',arrRecite.indexOf(item)!=-1?'read':'']"
                :key="item.index"
                @click="search(item)"
              >{{ item }}</div>
            </v-touch>
          </template>
        </div>
      </template>
      <!-- 此为全部单词列表 -->
      <template v-else v-for="item in list">
        <div
          class="tag"
          :id="item"
          v-if="Math.round(abcz.indexOf(item) + 1) != 0"
          :key="item.index"
        >{{ item }}</div>
        <div
          class="item"
          :class="[item==classActive ? 'classActive' : '',arrWord.indexOf(item)!=-1?'read':'']"
          v-else
          :key="item.index"
          @click="search(item)"
        >{{ item }}</div>
      </template>
    </div>
  </div>
</template>

<script>
// import readWord from "@/components/readWord.vue";
const sha256 = require("js-sha256").sha256; //引入sha256库
export default {
  name: "home",
  data: function() {
    return {
      list: [],
      ts: [],
      nav: 0,
      classActive: "",
      isRead: false,
      arrWord: [],
      arrRecite: [],
      abcz: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "G",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      ]
    };
  },
  components: {
    // readWord
  },
  created() {
    // 是在html渲染成之前执行
    if (JSON.parse(localStorage.getItem("arrWord"))) {
      this.arrWord = JSON.parse(localStorage.getItem("arrWord"));
    }
    if (localStorage.getItem("listBack") == null) {
      this.requestList();
    } else {
      this.list = JSON.parse(localStorage.getItem("listBack"));
    }
    if (localStorage.getItem("arrRecite") != null) {
      this.arrRecite = JSON.parse(localStorage.getItem("arrRecite"));
    }
  },
  mounted() {
    // 是在html渲染成之后执行
    window.addEventListener("scroll", function() {
      this.ts = [];
      // }
    });
  },
  methods: {
    // 清空在背单词列表
    clearNote() {
      this.arrRecite = []; // 背过的单词数
      this.arrWord = []; // 单词本里在背
      this.list = []; // 全部单词本内容
      localStorage.removeItem("arrWord");
      localStorage.removeItem("arrRecite");
    },
    // v-touch
    swiperleft(even) {
      if (this.arrRecite.indexOf(even) === -1) {
        this.arrRecite.push(even);
        localStorage.setItem("arrRecite", JSON.stringify(this.arrRecite));
      }
    },
    swiperright(even) {
      if (this.arrRecite.indexOf(even) != -1) {
        let i;
        for (i = 0; i < this.arrRecite.length; i++) {
          if (this.arrRecite[i] == even) {
            break;
          }
        }
        this.arrRecite.splice(i, 1);
        localStorage.setItem("arrRecite", JSON.stringify(this.arrRecite));
      }
    },
    swiperup(even) {
      if (this.arrRecite.indexOf(this.arrWord[even]) != -1) {
        let i;
        for (i = 0; i < this.arrRecite.length; i++) {
          if (this.arrRecite[i] == this.arrWord[even]) {
            break;
          }
        }
        this.arrRecite.splice(i, 1);
        localStorage.setItem("arrRecite", JSON.stringify(this.arrRecite));
      }
      this.arrWord.splice(even, 1);
      localStorage.setItem("arrWord", JSON.stringify(this.arrRecite));
    },
    // 第一词打开单词 请求单词列表
    requestList() {
      this.$axios.get("./word.json").then(
        response => {
          let list = [];
          list = response.data.word;
          for (let i = 0; i < list.length; i++) {
            if (this.abcz.indexOf(list[i]) != "-1") {
              list.splice(i, 1, list[i]);
            }
          }
          this.list = list;
          localStorage.setItem("listBack", JSON.stringify(list));
        },
        response => {
          alert(response.status);
        }
      );
    },
    // 切换今日已学
    tabRead() {
      if (this.isRead) {
        this.list = JSON.parse(localStorage.getItem("listBack"));
        this.isRead = !this.isRead;
      } else {
        this.list = this.arrWord;
        this.isRead = !this.isRead;
      }
    },
    closeNav() {
      // 导航头
      this.nav = !this.nav;
    },
    close() {
      // 搜索的单词详情
      this.ts = [];
    },
    search(even) {
      this.classActive = even;
      if (this.arrWord.indexOf(even) === -1) {
        this.arrWord.push(even);
        localStorage.setItem("arrWord", JSON.stringify(this.arrWord));
      }
      let appKey = "734e7ff45d43a8ad",
        key = "CASfskxokZFA72QMmLYZZPPPU9oMWuKG", //注意：暴露appSecret，有被盗用造成损失的风险
        salt = new Date().getTime(),
        curTime = Math.round(new Date().getTime() / 1000),
        query = even,
        // 多个query可以用\n连接  如 query='apple\norange\nbanana\npear'
        from = "auto",
        to = "auto",
        str1 = appKey + truncate(query) + salt + curTime + key,
        sign = sha256(str1);
      this.$http
        .jsonp(
          "https://openapi.youdao.com/api?q=" +
            query +
            "&&appKey=" +
            appKey +
            "&&salt=" +
            salt +
            "&&from=" +
            from +
            "&&to=" +
            to +
            "&&sign=" +
            sign +
            "&&signType=v3" +
            "&&curtime=" +
            curTime +
            "&&ext=mp3&&voice=0"
        )
        .then(res => {
          let that = this;
          // this.$router.push("/about");
          that.ts = res.data;
          // let sleep = setInterval(function() {
          //   that.ts = [];
          //   clearInterval(sleep);
          // }, 6000);
        })
        .catch(res => {
          window.console.log(res.status);
        });
      function truncate(q) {
        var len = q.length;
        if (len <= 20) return q;
        return q.substring(0, 10) + len + q.substring(len - 10, len);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.home {
  position: relative;
  // .readWord {
  //   position: fixed;
  // }
  // v-touch
  .wrapper {
    width: auto;
    .menu-container {
      width: auto;
    }
  }
  .todayWord {
    position: fixed;
    right: 0;
    bottom: 20vh;
    min-width: 40px;
    min-height: 30px;
    box-shadow: 0 0 5px #6e95ff;
    border-radius: 5px;
    padding: 10px;
    background-color: #f5f5ff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .navBtn {
    position: fixed;
    right: 5px;
    top: 5px;
    padding: 0 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ts {
    padding: 20px 0;
    background: #f5f5f5;
    box-shadow: 0 0 10px #ccc;
    border-radius: 5px;
    position: fixed;
    top: 30vh;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    .close {
      position: absolute;
      right: 10px;
      top: 10px;
      background: #f6f6f6;
      border-radius: 50%;
      display: block;
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .close1 {
        position: absolute;
        width: 25px;
        height: 3px;
        transform: rotate(45deg);
        background: #000;
        margin-top: 12px;
      }
      .close2 {
        position: absolute;
        width: 25px;
        height: 3px;
        transform: rotate(135deg);
        background: #000;
        margin-top: 12px;
      }
    }
    .inlineBlock {
      display: inline-block;
      font-size: 18px;
      color: rgb(110, 149, 255);
    }
    .flex {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .flexCl {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    .flexCll {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
    }
    .tranBox {
      padding: 20px;
    }
  }
  .wordBox {
    width: calc(100% - 40px);
    .topNote {
      display: flex;
      justify-content: space-around;
      text-align: center;
    }
    .listBox {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
    }
    .nav {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1001;
      width: calc(100% - 40px);
      min-height: 30px;
      padding: 10px 20px;
      text-align: center;
      background-color: #f6f6f6;
      box-shadow: 0 0 5px #000;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      a {
        color: #0298ac;
        padding: 8px;
        text-decoration: none;
      }
    }
    .item {
      margin: 5px 10px;
      padding: 5px;
      display: inline-block;
    }
    .tag {
      background-color: #a9ddff;
      padding-left: 10px;
    }
    .classActive {
      border-bottom: 2px solid #6e95ff;
    }
    .read {
      color: rgb(10, 108, 253);
    }
  }
  .font18 {
    font-size: 18px;
  }
  .blue {
    color: #6e95ff;
  }
}
</style>
